import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { IAudioDevice, ICreateAudioDevice, IUpdateAudioDevice } from '../../models';

@Injectable({ providedIn: 'root' })
export class AudioDeviceService {
  private http = inject(HttpClient);

  readonly endpoints = {
    audioDevices: `${environment.apiUrl}/audio-devices`,
  };

  getBysite(siteId: string): Observable<IAudioDevice[]> {
    return this.http.get<IAudioDevice[]>(this.endpoints.audioDevices, {
      params: { site_id: siteId },
    });
  }

  create(devices: ICreateAudioDevice[]): Observable<IAudioDevice[]> {
    return this.http.post<IAudioDevice[]>(this.endpoints.audioDevices, {
      devices,
    });
  }

  update(device: IUpdateAudioDevice): Observable<IAudioDevice> {
    return this.http.put<IAudioDevice>(this.endpoints.audioDevices, device);
  }

  delete(ids: string[]): Observable<{ deleted_ids: string[] }> {
    return this.http.delete<{ deleted_ids: string[] }>(this.endpoints.audioDevices, {
      body: { ids },
    });
  }
}
